<template>
    <section class="menu__page line-menu padding_menu" v-if="loaded">
      <div class="item" v-if="menuTop" v-for="menu in menuTop" :key="menu.id">
         <nuxt-link :class="{'active':isActive(menu.link)}" :to="menu.link" class="solid-hover" exact>{{menu.name}}</nuxt-link>
      </div>
    </section>
</template>
<script>
  import RouteMixin from "../shared/mixins/RouteMixin";

  export default {
    mixins: [RouteMixin],
    computed: {
      loaded() {
        return this.$store.state.menu.menuItems.top.loaded
      },
      menuTop() {
        return this.$store.getters['menu/menuTop'](this.urlParent(this.$route.path));
      },
    },
    methods: {
      isActive(url) {
        const parseUrl =  url.split('/');
        if(this.$route.params.category && parseUrl.indexOf(this.$route.params.category) !== -1) {
          return true
        } else if(url && this.$route.path === url) {
          return true
        } else if(url && url === this.$route.path.slice(0, -4)) {
          return true
        }
        return false
      }
    },
    watch: {
          menuTop(menuItem) {
              if(menuItem.length) {
                  const url = this.urlParentSub(this.$route.path) || null;
                  const value = menuItem.find((item)=>item.link === url);
                  this.$emit('currentMenu', value);
              }
          }
      },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .news-filter {
     padding: 3.5rem 0 1rem;
  }
  @media (max-width: $media_xs) {
     .menu__page {
       .item {
         width: 50%;
         text-align: center;
         a {
           font-size: 11px;
         }
       }
     }
  }
</style>



// WEBPACK FOOTER //
// components/news/MenuNews.vue